import { useMutation } from "@apollo/react-hooks";
import {T} from '../../../utils/I18n/I18n';
import {useTranslation} from "react-i18next";
import React, {useContext, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../../../context/UserContext";
import { GET_USER_DATA, UPDATE_CUSTOMER } from "../../../screens/PersonalAreaScreen/queriesPersonalArea";
import Button from '../../UI/Button/Button';
import FormInput from '../../UI/FormInput/FormInput';
import { usePopup } from "../../../context/PopupContext";

const EditName = () => {
    const { user } = useUserContext();
    const { firstname: defaultName, lastname: defaultLastName } = user || {};
    const { showAddToCartPopupMessage } = usePopup();
    const { t } = useTranslation();
    const history = useNavigate();
    const { register, handleSubmit, errors, setValue } = useForm();
    const [updateCustomerV2, {error: mutationError}] = useMutation(UPDATE_CUSTOMER, {
        refetchQueries: [{ query: GET_USER_DATA }],
    });

    const onSubmit = async submitData => {
        const { firstname, lastname } = submitData;
        await updateCustomerV2({ variables: { input: { firstname, lastname } } });
        history("/customer/account");
        showAddToCartPopupMessage(t('edit.success'), "success", 4000);
    };

    useEffect(() => {
        if(mutationError){
            if(mutationError.message.includes('First')){
                showAddToCartPopupMessage(t('edit.nameError'), "error", 4000);
            }
            if(mutationError.message.includes('Last')){
                showAddToCartPopupMessage(t('edit.lastnameError'), "error", 4000);
            }
            setValue('firstname', defaultName)
            setValue('lastname', defaultLastName);
        }
    }, [mutationError])

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="profile-form">
            <fieldset>
                <p className="profile-form__header">{<T id="edit.profileInfo" />}</p>
                <FormInput register={register} type="text" text={<T id="edit.name" />} name="firstname" errors={errors} defaultValue={defaultName} />
                <FormInput register={register} type="text" text={<T id="edit.lastname" />} name="lastname" errors={errors} defaultValue={defaultLastName} />
                <Button type="submit" trait="profile-hover" text={<T id="edit.submit" />} />
            </fieldset>
        </form>
    );
};

export default EditName;
